<div class="call-page">
    <!-- Page header -->
    <div class="call-header">
        <div class="call-header__left">
            <div class="call-title">通話紀錄審核中心</div>
            <div class="call-subtitle">語音與視訊通話活動查詢、審核與對帳</div>
        </div>
    </div>

    <!-- Filters -->
    <div class="call-filters">
        <div class="call-filters__left">
            <app-date
                [time]="time"
                [timeset]="timeset"
                (rangeSelected)="handleRangeSelected($event)">
            </app-date>

            <div class="select">
                <label>活動名稱</label>
                <select [(ngModel)]="activeType" (change)="applyFilters()">
                    <option default disabled value="-2">請選擇活動名稱</option>
                    <option *ngFor="let item of active_option_list" [ngValue]="item.id">{{item.name}}</option>
                </select>
            </div>

            <div class="select">
                <label>審核狀態</label>
                <select [(ngModel)]="list_type" (change)="applyFilters()">
                    <option *ngFor="let item of active_list_type" [ngValue]="item.id">{{item.name}}</option>
                </select>
            </div>

            <div class="select">
                <label>類型</label>
                <select [(ngModel)]="voiceType" (change)="applyFilters()">
                    <option value="-2">全部</option>
                    <option value="1">語音</option>
                    <option value="2">視訊</option>
                </select>
            </div>

        </div>

        <div class="call-filters__right">
            <div class="search">
                <input
                    type="text"
                    placeholder="搜尋 uid / 暱稱"
                    [(ngModel)]="keyword"
                    (keyup.enter)="applyFilters()"
                />
                <button class="btn-search" (click)="applyFilters()">查詢</button>
            </div>
        </div>
    </div>

    <!-- Table -->
    <div class="call-table card">
        <app-table-v2 class="bg-white" [data]="data" [tcontent]="tcontent" [type]="2">
            <ng-template let-post #operation_dk>
                <!-- From user cell -->
                <ng-container *ngIf="post.key == 'from_user_uid'">
                    <a  target="_blank" href="{{link}}/user/{{ post.val.from_user_uid}};act=1">
                        <div class="user-cell" >
                            <img loading="lazy" class="avatar" [src]="post.val.from_user_profile_pic || defaultAvatar" />
                            <div class="user-meta">
                                <div class="user-name">{{ post.val.from_user_name || '—' }}</div>
                                <div class="user-uid">{{ post.val.from_user_uid }}</div>
                            </div>
                            <span class="pill pill--out">撥出</span>
                        </div>
                    </a>

                </ng-container>

                <!-- To user cell -->
                <ng-container *ngIf="post.key == 'to_user_uid'">
                    <a  target="_blank" href="{{link}}/user/{{ post.val.to_user_uid}};act=1">
                        <div class="user-cell">
                            <img loading="lazy" class="avatar" [src]="post.val.to_user_profile_pic || defaultAvatar" />
                            <div class="user-meta">
                                <div class="user-name">{{ post.val.to_user_name || '—' }}</div>
                                <div class="user-uid">{{ post.val.to_user_uid }}</div>
                            </div>
                            <span class="pill pill--in">接收</span>
                        </div>
                    </a>
                </ng-container>

                <!-- Type badge -->
                <ng-container *ngIf="post.key == 'type'">
                    <span class="badge" [ngClass]="post.val.type == 1 ? 'badge--voice' : 'badge--video'">
                        {{ post.val.type == 1 ? '語音' : '視訊' }}
                    </span>
                </ng-container>

                <!-- Break status -->
                <ng-container *ngIf="post.key == 'break_status'">
                    <span class="badge badge--gray">
                        {{ post.val.break_status == 1 ? '對方掛' : '我掛' }}
                    </span>
                </ng-container>

                <!-- Secs -->
                <ng-container *ngIf="post.key == 'secs'">
                    <span class="secs">
                        {{ post.val.secs }}s
                        <small class="secs__hint">{{ formatSecs(post.val.secs) }}</small>
                    </span>
                </ng-container>

                <!-- Record -->
               <ng-container *ngIf="post.key === 'record_url'">
                    <div class="record-actions">
                        <!-- 有錄影 -->
                        <ng-container *ngIf="post.val.record_url; else noRecord">
                            <button
                                type="button"
                                class="record-btn"
                                [class.is-disabled]="isRecordExpired(post.val)"
                                [disabled]="isRecordExpired(post.val)"
                                [attr.title]="isRecordExpired(post.val) ? '已超過 7 天保存期限，錄影已自動清除' : '下載錄影'"
                                (click)="!isRecordExpired(post.val) && openRecord(post.val.record_url)">
                                下載
                            </button>

                            <span *ngIf="isRecordExpired(post.val)" class="record-badge">
                                已過期
                            </span>
                        </ng-container>

                        <!-- 沒錄影 -->
                        <ng-template #noRecord>
                            <span class="record-empty">—</span>
                        </ng-template>
                    </div>
                </ng-container>

                <!-- review_status -->
                <ng-container *ngIf="post.key === 'review_status'">
                    <div
                        class="review-btn-group"
                        [class.disabled]="isRecordExpired(post.val)"
                        [title]="isRecordExpired(post.val) ? '已超過 7 天，無法再進行審核' : ''"
                    >
                        <button
                            type="button"
                            [disabled]="isRecordExpired(post.val)"
                            [class.active]="post.val.review_status === 0"
                            (click)="setReviewStatus(post.val, 0)">
                            未審核
                        </button>

                        <button
                            type="button"
                            [disabled]="isRecordExpired(post.val)"
                            [class.active]="post.val.review_status === 1"
                            (click)="setReviewStatus(post.val, 1)">
                            符合
                        </button>

                        <button
                            type="button"
                            [disabled]="isRecordExpired(post.val)"
                            [class.active]="post.val.review_status === -1"
                            (click)="setReviewStatus(post.val, -1)">
                            不符合
                        </button>
                    </div>
                </ng-container>
            </ng-template>
        </app-table-v2>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>
